
let config={
    CLIENTID : 'com.masterhobbies.masterhobbie'
}

export default config